export default "__VITE_ASSET__BlLZyKSJ__"